import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AddressProvider } from './context/AddressContext';
import Login from './pages/Login';
import Layout from './components/Layout';
import PackageLayout from './components/PackageLayout';
import Home from './pages/Home';
import Addresses from './pages/Addresses';
import ScopeOfWork from './pages/ScopeOfWork';
import Leases from './pages/Leases';
import BankStatements from './pages/BankStatements';
import ClosingPacks from './pages/ClosingPacks';
import SettlementStatements from './pages/SettlementStatements';
import PayoffCalculator from './pages/PayoffCalculator';
import LeaseLedgers from './pages/LeaseLedgers';
import PackageExport from './pages/PackageExport';
import LenderProfiles from './pages/LenderProfiles';
import Settings from './pages/Settings';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <AddressProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Home + global tabs (no pack selected) */}
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Home />} />
              <Route path="lender-profiles" element={<LenderProfiles />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            {/* Inside a refi pack */}
            <Route path="/pack/:id" element={<ProtectedRoute><PackageLayout /></ProtectedRoute>}>
              <Route index element={<Addresses />} />
              <Route path="scope" element={<ScopeOfWork />} />
              <Route path="leases" element={<Leases />} />
              <Route path="bank-statements" element={<BankStatements />} />
              <Route path="closing-packs" element={<ClosingPacks />} />
              <Route path="settlement-statements" element={<SettlementStatements />} />
              <Route path="payoff-calculator" element={<PayoffCalculator />} />
              <Route path="lease-ledgers" element={<LeaseLedgers />} />
              <Route path="package-export" element={<PackageExport />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AddressProvider>
    </AuthProvider>
  );
}

export default App;
